export enum RelationType{

    /**
     * 与
     */
    // And=0,
    And = 1,

    /**
     * 或
     */
    // Or=1
    Or = 2
}